import React, { PropTypes } from 'react'; // eslint-disable-line no-unused-vars

const { shape, string } = PropTypes;

export default shape({
  filterID: string,
  userID: string,
  name: string,
  createdAt: string,
  updatedAt: string,
  query: string,
  deletedAt: string
});



// WEBPACK FOOTER //
// ./js/types/api/filter.js